module.exports = __webpack_public_path__ + "static/media/img_signin_agent.f8260aee.webp";